export enum FilterChatSearchE {
  NAME = 'NAME',
  CONTENT = 'CONTENT',
  EMAIL = 'EMAIL',
  PROTOCOL = 'PROTOCOL',
  TELEPHONE = 'TELEPHONE',
  TEAM = 'TEAM',
}
